import { render, staticRenderFns } from "./SubjectInfoComponents.vue?vue&type=template&id=c02ad022&scoped=true"
import script from "./SubjectInfoComponents.vue?vue&type=script&lang=js"
export * from "./SubjectInfoComponents.vue?vue&type=script&lang=js"
import style0 from "./SubjectInfoComponents.vue?vue&type=style&index=0&id=c02ad022&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02ad022",
  null
  
)

export default component.exports